const init = () => {
  const images = document.querySelectorAll("[data-background]");
  images.forEach(el => {
    el.style.backgroundImage =
      "url(" + el.getAttribute("data-background") + ")";
  });
};

module.exports = { init };
